export { default } from './product-comparison-grid';
